<template>
      <v-container>
    <v-card>
        <v-toolbar  dense  elevation="0">
            <v-icon left >mdi-playlist-plus</v-icon><span class="va-underline">Your Profile </span>
            <v-spacer/>
          
          </v-toolbar>
        <v-card-text>
             <v-form
                ref="form"
                class="mt-4"
                v-model="valid"
                lazy-validation
              >
              <v-row>
                <v-col cols="12">
                  <v-row>
                      <v-col cols="6">
                         <div ><v-icon small left >mdi-account</v-icon>Information</div>
                         <v-divider class="mb-4 mt-2"/>
                            <v-text-field
                          v-model="user.fullname"
                            label="Full Name *"
                           disabled
                            dense
                            :rules="textRules"
                          required
                          ></v-text-field>
                           <v-text-field
                          v-model="user.type"
                            label="Type"
                           disabled
                            dense
                            :rules="textRules"
                          required
                          ></v-text-field>
                           <v-text-field
                          v-model="user.role"
                            label="Role"
                           disabled
                            dense
                            :rules="textRules"
                          required
                          ></v-text-field>
                           <v-text-field
                            v-model="user.contact_no"
                              label="Contact No."
                              disabled
                              dense
                              :rules="textRules"
                            required
                          ></v-text-field> 
                           <v-text-field
                            v-model="user.email"
                              label="Email"
                             disabled
                              dense
                              :rules="textRules"
                            required
                          ></v-text-field> 
                         
                           <v-text-field
                            v-model="user.status"
                              label="Status"
                             disabled
                              dense
                              :rules="textRules"
                            required
                          ></v-text-field> 
                          
                         
                      </v-col>
                        <v-col cols="6">
                           <div ><v-icon small left >mdi-key</v-icon>Login Credentials</div>
                          <v-divider class="mb-4 mt-2"/>

                          <v-text-field
                           disabled
                              dense
                            v-model="user.username"
                              label="Username *"
                              :rules="textRules"
                            required
                            ></v-text-field>

                          
                        
                            <div class="mt-8 mb-2">
                              <div ><v-icon small left  @click="s3upload = true" >mdi-image</v-icon>Picture</div>
                          <v-divider class="mb-1 mt-2"/>
                              
                                  <img
                                    width="80%"
                                   @click="s3upload = true" class="imgsrc"
                                  v-if="user.profile != undefined && user.profile.picture  != undefined "
                                  :src="user.profile.picture"
                                  >
                                   <img v-else :src="$store.state.imgholder"  @click="s3upload = true" class="imgsrc"   width="200" />
                               
                              
                             </div>
                              <p>
                            Date Registered: {{$moment(this.user.created).format("MMM DD, YYYY")}}
                            <br/>
                            Last Login: {{$moment(this.user.last_login).format("MMM DD, YYYY hh:mm A")}}
                          </p>
                           
                        </v-col>
                  </v-row>
             
                </v-col>
               
              </v-row>
             </v-form>
        </v-card-text>
        
    </v-card>
</v-container>
</template>

<script>
   import {
     mapMutations
   } from 'vuex'

export default {
 
  data: () => ({
      valid: true,
      newpassword:'',
      changepass: false,
      s3upload: false,
      user:{},
      profile:{picture:"",address:""},
      experience:[],
      education:[],
      roles:[],
      user_types:[],
      show1: false,
      textRules: [
        v => !!v || 'Field is required'
      ],
  }),
  created() {
     if (this.$session.exists()) {
             this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
             this.setLoggedIn(true) 
             this.SETVARS()
             this.changepass = false
              this.s3upload = false
             setTimeout(()=>{this.getUser()}, 500)
     }      
    
  },
  computed: {
 
      
  },
  
  methods: {
     ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn','setVariables']),
    s3Ev(e){
      if(e) {
        this.profile.picture = e[0]
        console.log(this.profile.picture)
        this.user.profile = this.profile
        this.s3upload = false
      }
      
    },
      validate () {
         this.user.profile = this.profile
         if(this.user.status != 'Active') {
          this.user.status = "Deactivated"
         }
        if (this.$refs.form.validate()) {
          this.show1 = false
          this.Update()
        }
      },

    getUser() { 
          this.VA_ALERT('info', 'Loading users data', 'progress', 100, 1500)
          var userID =this.$IsNum(this.$session.get("userID"))
           this.user = {}
            this.QUERY('vendors','select * from users where id=' + userID, (res)=>{
              console.log(res)
              if(res.status) {
                  this.user = res.results[0]
              }
              
            })
        },
      Update(){
         
           this.$http.post("update_user", this.user).then(response => {
          this.VA_ALERT(response.data.status?'success':'error', response.data.message, response.data.status?'check':'close', 500, 2000)
          if(response.data.status){
              this.emitToParent()
          }
        }).catch(e => {
          console.log(e.data)
        })
    },
    ChangePassword() {
      if( this.newpassword == '') {
        this.VA_ALERT('error', 'Please enter your new password!',"close", 500, 2000)
        return
      }
          this.$http.post("update_password", {id: this.user.id, password: this.newpassword}).then(response => {
          this.VA_ALERT(response.data.status?'success':'error', response.data.message, response.data.status?'check':'close', 500, 2000)
          if(response.data.status){
             this.changepass = false

          }
        }).catch(e => {
          console.log(e.data) 
        })
     },
    emitToParent (action) {
      if(this.show1) {
        this.user.password = this.newpassword
      }
      console.log(this.user)
      this.$emit('DialogEvent', {action: action, user:this.user})
    }

  }
}
</script>
